import { Mesh, MeshBasicMaterial, OctahedronGeometry } from "three/webgpu";
import Experience from "../Experience";
import { LANE_X } from "./TrackManager";

const POOL_SIZE = 24;
const SPAWN_FAR_Z = 110;
const SPAWN_NEAR_Z = 25;
const DESPAWN_BEHIND_Z = -12;
const GEM_HEIGHT = 1.0;
const GEM_RADIUS = 0.4;
const COLLECT_RADIUS_Z = 1.4;
const COLLECT_RADIUS_X = 1.2;
const SPAWN_GAP_MIN = 8;
const SPAWN_GAP_MAX = 28;

export default class Pickups {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;

    this.geometry = new OctahedronGeometry(GEM_RADIUS, 0);
    this.material = new MeshBasicMaterial({ color: 0xffe066 });
    this.material.color.multiplyScalar(2.5);

    this.gems = [];
    for (let i = 0; i < POOL_SIZE; i++) {
      const mesh = new Mesh(this.geometry, this.material);
      mesh.visible = false;
      this.scene.add(mesh);
      this.gems.push({ mesh, alive: false, z: 0, lane: 1 });
    }
  }

  reset() {
    for (const g of this.gems) {
      g.alive = false;
      g.mesh.visible = false;
    }
    const tm = this._tm();
    if (!tm) return;
    let z = SPAWN_NEAR_Z;
    for (const g of this.gems) {
      if (z >= SPAWN_FAR_Z) break;
      this._spawnAt(g, z, tm);
      z += SPAWN_GAP_MIN + Math.random() * (SPAWN_GAP_MAX - SPAWN_GAP_MIN);
    }
  }

  update(delta, scrollSpeed) {
    const tm = this._tm();
    if (!tm) return 0;
    const train = this.experience.world && this.experience.world.train;
    const trainX = train && train.group ? train.group.position.x : 0;

    const dz = scrollSpeed * delta;
    let collected = 0;

    for (const g of this.gems) {
      if (!g.alive) continue;
      g.z -= dz;
      g.mesh.position.z = g.z;
      g.mesh.rotation.y += delta * 2.4;
      g.mesh.rotation.x += delta * 1.1;

      const dx = LANE_X[g.lane] - trainX;
      if (Math.abs(g.z) < COLLECT_RADIUS_Z && Math.abs(dx) < COLLECT_RADIUS_X) {
        collected++;
        this._respawnAhead(g, tm);
        const audio = this.experience.audio;
        if (audio) audio.playGem();
      } else if (g.z < DESPAWN_BEHIND_Z) {
        this._respawnAhead(g, tm);
      }
    }
    return collected;
  }

  _respawnAhead(gem, tm) {
    let farthest = SPAWN_FAR_Z - SPAWN_GAP_MAX;
    for (const g of this.gems) {
      if (g === gem || !g.alive) continue;
      if (g.z > farthest) farthest = g.z;
    }
    const gap = SPAWN_GAP_MIN + Math.random() * (SPAWN_GAP_MAX - SPAWN_GAP_MIN);
    this._spawnAt(gem, farthest + gap, tm);
  }

  _spawnAt(gem, z, tm) {
    const lane = tm.getLaneAtZ(z);
    if (lane === null) {
      gem.alive = false;
      gem.mesh.visible = false;
      return;
    }
    gem.lane = lane;
    gem.z = z;
    gem.alive = true;
    gem.mesh.visible = true;
    gem.mesh.position.set(LANE_X[lane], GEM_HEIGHT, z);
  }

  _tm() {
    return this.experience.world && this.experience.world.trackManager;
  }
}
